<div class="csv-import">

  <div class="csv-header">
    <div>
      <h4>{{ 'CSV_IMPORT.TITLE' | translate }}</h4>
      <p class="csv-subtitle">
        {{ blastName }} <span *ngIf="plannedHoleCount">&mdash; {{ plannedHoleCount }} {{ 'CSV_IMPORT.PLANNED_HOLES' | translate }}</span>
      </p>
    </div>
    <button type="button" class="close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
  </div>

  <!-- Fil d'étapes -->
  <div class="csv-steps">
    <div class="csv-step" *ngFor="let label of ['FILE','COLUMNS','METHOD','VALIDATION']; let i = index"
         [class.active]="step() === i + 1" [class.done]="step() > i + 1">
      <span class="csv-step-badge">{{ step() > i + 1 ? '✓' : i + 1 }}</span>
      <span class="csv-step-label">{{ 'CSV_IMPORT.STEP_' + label | translate }}</span>
    </div>
  </div>

  <div class="csv-body">

    <!-- 1. Fichier -->
    <ng-container *ngIf="step() === 1">
      <input type="file" id="csvHoleFileInput" accept=".csv,.dxf,.str" hidden (change)="onFileSelected($event)" />

      <div class="csv-dropzone" *ngIf="!fileName()"
           (click)="triggerFilePicker()" (drop)="onFileDropped($event)" (dragover)="allowDrop($event)">
        <i class="fas fa-folder-open"></i>
        <strong>{{ 'CSV_IMPORT.DROP_HERE' | translate }}</strong>
        <small>{{ 'CSV_IMPORT.ACCEPTED_FORMATS' | translate }}</small>
      </div>

      <div class="csv-file" *ngIf="fileName()">
        <div>
          <strong>{{ fileName() }}</strong>
          <small>{{ fileSizeKb() }} KB</small>
        </div>
        <button type="button" class="btn btn-secondary" (click)="triggerFilePicker()">
          {{ 'CSV_IMPORT.CHANGE_FILE' | translate }}
        </button>
      </div>

      <div class="csv-note">
        <i class="fas fa-info-circle"></i>
        <span>{{ 'CSV_IMPORT.PARTIAL_NOTE' | translate }}</span>
      </div>

      <!-- Inverse X et Y avant tout traitement, comme dans l'import STR historique -->
      <div class="csv-swap" *ngIf="fileName()">
        <label>
          <input type="checkbox" [(ngModel)]="swapXY" />
          <span>{{ 'GLOBAL.SWAPXY' | translate }}</span>
        </label>
      </div>

      <!-- Un STR ou un DXF porte sa propre structure : ni mappage ni EPSG à choisir -->
      <div class="csv-note" *ngIf="fileName() && !isCsv()">
        <i class="fas fa-file-code"></i>
        <span>{{ 'CSV_IMPORT.NON_CSV_NOTE' | translate }}</span>
      </div>
    </ng-container>

    <!-- 2. Colonnes -->
    <ng-container *ngIf="step() === 2">
      <h6 class="csv-section-title">{{ 'CSV_IMPORT.COLUMN_MAPPING' | translate }}</h6>

      <table class="csv-mapping">
        <thead>
          <tr>
            <th>{{ 'CSV_IMPORT.CSV_COLUMN' | translate }}</th>
            <th>{{ 'CSV_IMPORT.SAMPLE' | translate }}</th>
            <th>{{ 'CSV_IMPORT.MATCHES' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let header of headers()">
            <td><code>{{ header }}</code></td>
            <!-- Voir la valeur réelle lève l'ambiguïté entre degrés et mètres projetés -->
            <td class="csv-sample">{{ sample()[header] }}</td>
            <td>
              <select class="form-control" [ngModel]="mapping()[header]"
                      (ngModelChange)="setMapping(header, $event)">
                <option value="ignore">{{ 'CSV_IMPORT.FIELD_IGNORE' | translate }}</option>
                <option value="name">{{ 'CSV_IMPORT.FIELD_NAME' | translate }}</option>
                <option value="x">{{ 'CSV_IMPORT.FIELD_X' | translate }}</option>
                <option value="y">{{ 'CSV_IMPORT.FIELD_Y' | translate }}</option>
                <option value="z">{{ 'CSV_IMPORT.FIELD_Z' | translate }}</option>
                <option value="length">{{ 'CSV_IMPORT.FIELD_LENGTH' | translate }}</option>
                <option value="depth">{{ 'CSV_IMPORT.FIELD_DEPTH' | translate }}</option>
                <option value="azimuth">{{ 'CSV_IMPORT.FIELD_AZIMUTH' | translate }}</option>
                <option value="angle">{{ 'CSV_IMPORT.FIELD_ANGLE' | translate }}</option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>

      <h6 class="csv-section-title">{{ 'CSV_IMPORT.EPSG_SECTION' | translate }}</h6>
      <div class="csv-epsg">
        <label for="csvEpsg">{{ 'CSV_IMPORT.SOURCE_EPSG' | translate }}</label>
        <input id="csvEpsg" type="number" class="form-control" [(ngModel)]="sourceEpsg" placeholder="32632" />
      </div>

      <!-- Un CSV peut contenir des degrés plutôt que des mètres projetés :
           c'est l'EPSG saisi qui tranche, pas le nom des colonnes. -->
      <p class="csv-hint">{{ 'CSV_IMPORT.EPSG_HINT' | translate }}</p>
    </ng-container>

    <!-- 3. Méthode -->
    <ng-container *ngIf="step() === 3">
      <h6 class="csv-section-title">{{ 'CSV_IMPORT.DATA_TYPE' | translate }}</h6>

      <div class="csv-choices">
        <button type="button" class="csv-choice" [class.selected]="dataType === DataType.Planned"
                (click)="selectDataType(DataType.Planned)">
          <strong>{{ 'CSV_IMPORT.PLANNED' | translate }}</strong>
          <span>{{ 'CSV_IMPORT.PLANNED_HELP' | translate }}</span>
        </button>
        <button type="button" class="csv-choice" [class.selected]="dataType === DataType.Measured"
                (click)="selectDataType(DataType.Measured)">
          <strong>{{ 'CSV_IMPORT.MEASURED' | translate }}</strong>
          <span>{{ 'CSV_IMPORT.MEASURED_HELP' | translate }}</span>
        </button>
      </div>

      <!-- Sous-choix planifié -->
      <ng-container *ngIf="dataType === DataType.Planned">
        <h6 class="csv-section-title">{{ 'CSV_IMPORT.PLANNED_MODE' | translate }}</h6>
        <button type="button" class="csv-choice wide" [class.selected]="plannedMode === PlannedMode.Replace"
                (click)="plannedMode = PlannedMode.Replace">
          <strong>{{ 'CSV_IMPORT.REPLACE' | translate }}</strong>
          <span>{{ 'CSV_IMPORT.REPLACE_HELP' | translate }}</span>
        </button>
        <button type="button" class="csv-choice wide" [class.selected]="plannedMode === PlannedMode.Append"
                (click)="plannedMode = PlannedMode.Append">
          <strong>{{ 'CSV_IMPORT.APPEND' | translate }}</strong>
          <span>{{ 'CSV_IMPORT.APPEND_HELP' | translate }}</span>
        </button>

        <p class="csv-danger" *ngIf="plannedMode === PlannedMode.Replace">
          <i class="fas fa-exclamation-triangle"></i> {{ 'CSV_IMPORT.REPLACE_WARNING' | translate }}
        </p>
      </ng-container>

      <!-- Sous-choix mesuré -->
      <ng-container *ngIf="dataType === DataType.Measured">
        <h6 class="csv-section-title">{{ 'CSV_IMPORT.MATCHING_METHOD' | translate }}</h6>
        <button type="button" class="csv-choice wide" [class.selected]="matchingMethod === Matching.ByName"
                (click)="matchingMethod = Matching.ByName">
          <strong>{{ 'CSV_IMPORT.BY_NAME' | translate }}</strong>
          <span>{{ 'CSV_IMPORT.BY_NAME_HELP' | translate }}</span>
        </button>
        <button type="button" class="csv-choice wide" [class.selected]="matchingMethod === Matching.ByNearestNeighbour"
                (click)="matchingMethod = Matching.ByNearestNeighbour">
          <strong>{{ 'CSV_IMPORT.BY_NEIGHBOUR' | translate }}</strong>
          <span>{{ 'CSV_IMPORT.BY_NEIGHBOUR_HELP' | translate }}</span>
        </button>

        <div class="csv-distance" *ngIf="matchingMethod === Matching.ByNearestNeighbour">
          <label for="csvMaxDistance">{{ 'CSV_IMPORT.MAX_DISTANCE' | translate }}</label>
          <input id="csvMaxDistance" type="number" step="0.1" min="0"
                 class="form-control" [(ngModel)]="maxMatchingDistance" />
          <span class="csv-unit">m</span>
        </div>
      </ng-container>
    </ng-container>

    <!-- 4. Validation -->
    <ng-container *ngIf="step() === 4 && validation() as report">
      <div class="csv-summary">
        <div class="csv-tile">
          <span class="csv-tile-value">{{ report.detectedHoles }}</span>
          <span class="csv-tile-label">{{ 'CSV_IMPORT.DETECTED' | translate }}</span>
        </div>
        <div class="csv-tile ok">
          <span class="csv-tile-value">{{ report.validHoles }}</span>
          <span class="csv-tile-label">{{ 'CSV_IMPORT.VALID' | translate }}</span>
        </div>
        <div class="csv-tile warn">
          <span class="csv-tile-value">{{ report.warningCount }}</span>
          <span class="csv-tile-label">{{ 'CSV_IMPORT.WARNINGS' | translate }}</span>
        </div>
        <div class="csv-tile error" *ngIf="report.errorCount">
          <span class="csv-tile-value">{{ report.errorCount }}</span>
          <span class="csv-tile-label">{{ 'CSV_IMPORT.ERRORS' | translate }}</span>
        </div>
      </div>

      <div class="csv-issue" *ngFor="let issue of report.issues"
           [class.is-error]="isError(issue)">
        <i class="fas" [ngClass]="isError(issue) ? 'fa-times-circle' : 'fa-exclamation-triangle'"></i>
        <span>{{ issue.message }}</span>
      </div>

      <p class="csv-all-good" *ngIf="!report.issues.length">
        <i class="fas fa-check-circle"></i> {{ 'CSV_IMPORT.NO_ISSUE' | translate }}
      </p>
    </ng-container>

    <!-- 5. Renommage proposé par le fichier STR. Hors du fil d'étapes : les trous
         sont déjà importés, seul le nom du tir reste à trancher. -->
    <ng-container *ngIf="step() === 5">
      <h6 class="csv-section-title">{{ 'GLOBAL.BLAST_NAME_UPDATE' | translate }}</h6>

      <div class="csv-file">
        <div>
          <small>{{ blastName }}</small>
          <strong>&rarr; {{ proposedBlastName() }}</strong>
        </div>
      </div>

      <p class="csv-hint">{{ 'GLOBAL.BLAST_UPDATE_CONFIRM' | translate }}</p>
    </ng-container>

  </div>

  <div class="csv-footer">
    <span class="csv-footer-note" *ngIf="step() === 4 && validation() as report">
      {{ report.canImport ? ('CSV_IMPORT.CAN_CONTINUE' | translate) : ('CSV_IMPORT.BLOCKED' | translate) }}
    </span>

    <!-- À l'étape 5 l'import est déjà écrit : ni revenir en arrière ni annuler n'a de sens -->
    <button type="button" class="btn btn-secondary" *ngIf="step() > 1 && step() < 5" (click)="back()" [disabled]="busy()">
      &larr; {{ 'GLOBAL.RETOUR' | translate }}
    </button>
    <button type="button" class="btn btn-secondary" *ngIf="step() < 5" (click)="cancel()" [disabled]="busy()">
      {{ 'GLOBAL.ANNULER' | translate }}
    </button>

    <button type="button" class="btn btn-secondary" *ngIf="step() === 5" (click)="declineRename()" [disabled]="busy()">
      {{ 'GLOBAL.NON' | translate }}
    </button>
    <button type="button" class="btn btn-primary" *ngIf="step() === 5" (click)="confirmRename()" [disabled]="busy()">
      {{ 'GLOBAL.OUI' | translate }}
    </button>

    <button type="button" class="btn btn-primary" *ngIf="step() === 1"
            [disabled]="!fileName() || busy()" (click)="continueFromFile()">
      {{ (isCsv() ? 'GLOBAL.CONTINUER' : 'CSV_IMPORT.RUN_IMPORT') | translate }}
      <span *ngIf="isCsv()">&rarr;</span>
    </button>
    <button type="button" class="btn btn-primary" *ngIf="step() === 2"
            [disabled]="!mappingIsComplete || busy()" (click)="step.set(3)">
      {{ 'GLOBAL.CONTINUER' | translate }} &rarr;
    </button>
    <button type="button" class="btn btn-primary" *ngIf="step() === 3"
            [disabled]="!methodIsComplete || busy()" (click)="goToValidation()">
      {{ 'GLOBAL.CONTINUER' | translate }} &rarr;
    </button>
    <button type="button" class="btn btn-success" *ngIf="step() === 4"
            [disabled]="busy() || !validation()?.canImport" (click)="runImport()">
      ✓ {{ 'CSV_IMPORT.RUN_IMPORT' | translate }}
    </button>
  </div>

</div>
